module.exports = __webpack_public_path__ + "static/media/9DESA6.dd889a55.jpg";